<template>
  <div class="container mw-960" slot="layout-body">
    <div class="error-container text-center">
      <img src="@/assets/images/signin-lcic-inactive.svg">
      <div
        class="typography-headline-6"
        v-html="$t('errors.not_found_msg')">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'not-found',
};
</script>
